import { apiClient } from "../../../../utils/api";
import { services } from "../../../../constants/services";

export const UpdateFromArrayReactionsService = async (data:any): Promise<any> => {
  return await apiClient.put(`${services.reactions}/update-from-array`, data);
};